export function getApiKey() {
    const isDevelopment = process.env.NODE_ENV == null || process.env.NODE_ENV === 'development';
    return isDevelopment ? 'AIzaSyBogndZQbVrrr5vDWn3lYQUG9UVMH18fds' : 'AIzaSyCcBuu5d12wU7pWonTMveGGrKflHpc_WTI';
}